// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"styles_chartWrapper__2RfoV","positionIcon":"styles_positionIcon__3m2QS"};